import { renderSlot as _renderSlot, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: /*@__PURE__*/_normalizeClass([
        'gfu-floating-message',
        'gfu-floating-notification-box',
    ])
}
const _hoisted_2 = { class: "gfu-media" }
const _hoisted_3 = { class: "_ml-1" }
const _hoisted_4 = { class: "gfu-hd gfu-bt--b2" }
const _hoisted_5 = { class: "gfu-bt gfu-bt--caption _tc--gray" }
const _hoisted_6 = { class: "_flexaicntr" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_progress_overlay = _resolveComponent("progress-overlay")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _renderSlot(_ctx.$slots, "icon"),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("h2", _hoisted_4, _toDisplayString($props.title), 1 /* TEXT */),
        _createElementVNode("span", _hoisted_5, _toDisplayString($props.description), 1 /* TEXT */),
        _createElementVNode("div", _hoisted_6, [
          _renderSlot(_ctx.$slots, "actions")
        ])
      ])
    ]),
    _createVNode(_component_progress_overlay, { visible: $props.isProcessing }, null, 8 /* PROPS */, ["visible"])
  ]))
}